export default "__VITE_ASSET__Bya76phY__"